import React from 'react'

import { Text } from '@/components/ui/text'
import { TooltipInfo } from '@/components/ui/tooltip-v2'

interface ReferralInformationOverviewProps {
  title: string
  tooltipContent: string
  isFetching: boolean
}

export const ReferralInformationOverview = ({
  title,
  tooltipContent,
  isFetching,
  children,
}: React.PropsWithChildren<ReferralInformationOverviewProps>) => {
  return (
    <div className='px-2 md:px-0 flex md:block flex-col items-center justify-center last:flex-1'>
      <div className='flex items-center gap-1'>
        <Text as='p' className='text-center'>
          {title}
        </Text>
        <TooltipInfo content={tooltipContent} iconClassName='icon' />
      </div>
      <Text size={22} as='p' className='mt-2' isLoading={isFetching}>
        {children}
      </Text>
    </div>
  )
}
